import {useMutation, useQueryClient} from '@tanstack/react-query';
import {QUERY_CACHE_KEYS} from '@chekin/core';
import {API} from '@chekin/api';
import type {PrintedCardsResponse} from '@chekin/api';

type Props = {
  onError?: (error: Error) => void;
  onSuccess?: () => void;
};

function useMutatePrintedCard({onError, onSuccess}: Props = {}) {
  const queryClient = useQueryClient();

  return useMutation<PrintedCardsResponse, Error, string>({
    mutationFn: (reservationId: string) => API.kiosko.addPrintedCard(reservationId),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: [QUERY_CACHE_KEYS.printedCards]});
      onSuccess?.();
    },
    onError,
  });
}

export {useMutatePrintedCard};
